import { axiosFormInstance, axiosInstance } from './axiosInstances';

export const addData = async (endpoint: string, requestBody?: object) => {
  try {
    const result = await axiosInstance.post(endpoint, requestBody);
    return result;
  } catch (error: any) {
    return error;
  }
};

export const addFormData = async (endpoint: string, requestBody?: object) => {
  try {
    const result = await axiosFormInstance.post(endpoint, requestBody);
    return result;
  } catch (error: any) {
    return error;
  }
};

export const updateData = async (endpoint: string, requestBody?: object) => {
  try {
    const result = await axiosInstance.patch(endpoint, requestBody);
    return result;
  } catch (error: any) {
    return error;
  }
};


export const updateFormData = async (
  endpoint: string,
  requestBody?: object
) => {
  try {
    const result = await axiosFormInstance.patch(endpoint, requestBody);
    return result;
  } catch (error: any) {
    return error;
  }
};

export const deleteData = async (endpoint: string) => {
  try {
    const result = await axiosInstance.delete(endpoint);
    return result;
  } catch (error: any) {
    return error;
  }
};

export const getAllData = async (url: string) => {
  try {
    let result = await axiosInstance.get(url);
    return result;
  } catch (error:any) {
    return error.response;
  }
};